export default import.meta.ROLLDOWN_FILE_URL_U7qJiysz5ZuhEgSdAd7riA